export default "__VITE_ASSET__emuQXE_N__"